import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { Lock, Lightning } from "@phosphor-icons/react";

export default function DashboardLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Συμπλήρωσε email και κωδικό");
      return;
    }
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Καλώς ήρθες πίσω.");
      navigate("/dashboard");
    } catch (err) {
      const msg = err.response?.data?.detail || "Σφάλμα σύνδεσης";
      toast.error(typeof msg === "string" ? msg : "Σφάλμα σύνδεσης");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="dashboard-login-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <form
        data-testid="dashboard-login-form"
        onSubmit={onSubmit}
        className="w-full max-w-md border border-white/10 bg-[#141414] p-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#E50000] flex items-center justify-center">
            <Lightning size={20} weight="bold" className="text-white" />
          </div>
          <div>
            <p className="text-overline">Admin</p>
            <h1 className="font-display font-black uppercase text-2xl">Dashboard</h1>
          </div>
        </div>

        <Field label="Email">
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="dash-input"
            autoComplete="email"
          />
        </Field>
        <Field label="Κωδικός">
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" weight="bold" />
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="dash-input pl-10"
              autoComplete="current-password"
            />
          </div>
        </Field>

        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={submitting}
          className="btn-primary w-full text-xs mt-2 disabled:opacity-50"
        >
          {submitting ? "Σύνδεση..." : "Είσοδος"}
        </button>
      </form>

      <style>{`
        .dash-input {
          width: 100%;
          background: #1A1A1A;
          border: 1px solid rgba(255,255,255,0.15);
          color: white;
          padding: 0.85rem 1rem;
          font-family: 'Manrope', sans-serif;
          font-size: 0.95rem;
          outline: none;
          border-radius: 2px;
        }
        .dash-input:focus { border-color: #E50000; }
      `}</style>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block mb-5">
      <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-white/60 mb-2">{label}</span>
      {children}
    </label>
  );
}
